var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[_c('common-structure-news',{staticClass:"pa-5",scopedSlots:_vm._u([{key:"detail",fn:function(){return [_vm._v(" Important product updates, news and selected articles from the market. Click on any article below to read more… ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }